import {PAYMENT_RESULT_RESPONSE} from '../actions/payment.actions';

export default function payment(state = {}, action) {
  switch (action.type) {
    case PAYMENT_RESULT_RESPONSE: {
      let nextState = {...state};
      nextState.paymentResult = action.paymentResult;
      return nextState;
    }
  }
  return state;
}
